import React from 'react';
import { useGetTripsByCargoId } from 'api/trips/use-get-trips-by-cargo-id.ts';
import { TripsList } from 'components/trips/trips-list';

interface ICargoTripsTableProps {
  cargoId: number;
}

export const CargoTripsTable: React.FC<ICargoTripsTableProps> = (props) => {
  const { cargoId } = props;
  const { data: trips, isLoading } = useGetTripsByCargoId({ cargoId });

  return <TripsList trips={trips?.data || []} isLoading={isLoading} withoutValues isForSpecificCargo withoutSummary />;
};
